import {POISearchScenario} from "./POISearchScenario";

export interface ISearchScenariosResult {
    scenarios: POISearchScenario[];
    totalScenarios: number;
}

export class SearchScenariosResult implements ISearchScenariosResult {
    scenarios: POISearchScenario[];
    totalScenarios: number;

    constructor() {
        this.scenarios = [];
        this.totalScenarios = 0;
    }
}